import React, { useEffect, useState } from "react";
import { useConfrontationStore } from "../../../../store/ConfrontationStore";
import { ColumnItem } from "../../../../../../common/models/table";
import { ConfrontationService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { ActionsKey } from "../../../../../../common/models/Actions";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../../../../common/components/LFTable/LFTableV3";
import { CustomDrawer } from "../../../../../../common/components/Drawer/CustomDrawer";
import {
  useQueryConfrontationStateSelect,
  useQueryConfrontationTypeSelect,
} from "../../../../core/_hooks";
import { ConfrontationDetail } from "../ConfrontationDetail";

type PropsType = {
  movementId: number;
};

export const EmbarkingConfrontation = ({ movementId }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false);
  const { data: confrontationState, isLoading: isLoadingConfrontationState } =
    useQueryConfrontationStateSelect();

  const { data: confrontationType, isLoading: isLoadingConfrontationType } =
    useQueryConfrontationTypeSelect();
  const {
    actioned,
    detail,
    list,
    pageState,
    resetPageState,
    setActioned,
    setPageState,
    totalItems,
    setConfrontationList,
  } = useConfrontationStore();

  const cols: ColumnItem[] = [
    {
      key: "operationLoad",
      title: "Identifiant",
      dataIndex: "operationLoad",
      show: true,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.uniqueIdentifier}</span>
          </div>
        );
      },
    },
    {
      key: "operationLoad",
      title: "Type",
      dataIndex: "operationLoad",
      show: true,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.loadType?.name}</span>
          </div>
        );
      },
    },
    {
      key: "state",
      title: "Status",
      dataIndex: "state",
      show: true,
      searchType: "select",
      nestedKey: "state",
      searchKey: "state",
      isLoading: isLoadingConfrontationState,
      searchOptions: confrontationState,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "type",
      title: "Type de confrontation",
      dataIndex: "type",
      show: true,
      searchType: "select",
      nestedKey: "type",
      searchKey: "type",
      isLoading: isLoadingConfrontationType,
      searchOptions: confrontationType,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "signaledBy",
      title: "Signalé par",
      dataIndex: "signaledBy",
      show: true,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.fullname}</span>
          </div>
        );
      },
    },
    {
      key: "createdAt",
      title: "Date de signalement",
      dataIndex: "createdAt",
      show: true,
    },
    {
      key: "processedBy",
      title: "Traité par",
      dataIndex: "processedBy",
      show: true,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.fullname ?? "-"}</span>
          </div>
        );
      },
    },
    {
      key: "processedAt",
      title: "Date de traitement",
      dataIndex: "processedAt",
      show: true,
    },
  ];

  useEffect(() => {
    resetPageState();
  }, [movementId]);

  useEffect(() => {
    fetchAllConfrontation({
      ...pageState,
    });
  }, [pageState]);

  const fetchAllConfrontation = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await ConfrontationService.getConfrontationList({
        ...params,

        "operationLoad.movement": movementId,
      });
      if (res?.status === HttpStatusCode.Ok) {
        setConfrontationList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onShowDrawerHandler = () => {
    setIsShowDrawer((prev: boolean) => !prev);
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "read") {
      getOne(item?.id, action);
    } else {
    }
  };
  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await ConfrontationService.getConfrontationById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowDrawerHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />

      <LFTableV3
        columns={cols}
        data={list}
        params={pageState}
        onAction={onActionClick}
        isCanEdit={() => false}
        isCanDelete={() => false}
        isCanShow={() => true}
        onSearch={handleSetParams}
        onSort={handleSetParams}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={handleSetParams}
      />

      {isShowDrawer ? (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={onShowDrawerHandler}
          title={actioned?.action === "read" ? "Détails" : ""}
          width={"75%"}
        >
          <ConfrontationDetail data={actioned?.data} />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};
